import React, { useEffect, useState } from "react";
import { SlotCorrectionResult } from "../../../../Model/SlotCorrection";
import MtiButton from "../../../Buttons/MtiButton";
import CommonDropDown from "../../../Common/DropDown/CommonDropDown";
import { ESlotCorrectionStatus } from "../../../../Model/ESlotCorrectionStatus";
import { CartesianWaypoint } from "../../../../Model/Waypoint";
import AutoCalibrationUtil from "../../../../Utility/AutoCalibrationUtil";
import CheckBox from "../../../Buttons/CheckBox";
import TextBox from "../../../Common/TextBox";
import CalibrationApi from "../../../../api/CalibrationApi";
import "./SlotCorrection.css";
import ToolsApi from "../../../../api/ToolsApi";
import { CartesianCoordinate } from "../../../../Model/Coordinate";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import { EModuleType } from "../../../../Model/EModuleType";
import { getModules } from "../../../../redux/reducers/ModuleReducer";
import { EAutoCalibrationResult } from "../../../../Model/EAutoCalibrationResult";

type Props = {
  slotCorrectionResults: SlotCorrectionResult[];
  setSlotCorrectionResults: (results: SlotCorrectionResult[]) => void;
  isSlotCorrectionUpdated: boolean;
  setIsSlotCorrectionUpdated: (isSlotCorrectionUpdated: boolean) => void;
  updatedSlotCorrectionResults: SlotCorrectionResult[];
  setUpdatedSlotCorrectionResults: (results: SlotCorrectionResult[]) => void;
  setNeedFetChSlotCorrectionResult: (needFetch: boolean) => void;
};

type StatusValue = {
  display: string;
  value: ESlotCorrectionStatus;
  disabled: boolean;
};

export default function CorrectionResultContent({
  slotCorrectionResults,
  setSlotCorrectionResults,
  isSlotCorrectionUpdated,
  setIsSlotCorrectionUpdated,
  updatedSlotCorrectionResults,
  setUpdatedSlotCorrectionResults,
  setNeedFetChSlotCorrectionResult,
}: Props) {
  const header: string[] = [
    "Carrier",
    "Hotel",
    "Slot",
    "Store X",
    "Store Y",
    "Store Z",
    "Retrive X",
    "Retrive Y",
    "Retrive Z",
    "Status",
  ];

  const Divider = () => {
    return (
      <hr
        style={{
          border: "1px solid #E0E0E0",
          height: 32,
        }}
      />
    );
  };

  const [selectedSlotCorrection, setSelectedSlotCorrection] = useState(
    [] as SlotCorrectionResult[]
  );
  //Todo: change this when multi chamber implemented
  const chamberModules = useTypedSelector((state) =>
    getModules(state, EModuleType.CHAMBER)
  );
  const chamberModule = chamberModules[0];

  const handleSlotCorrection = (slotCorrection: SlotCorrectionResult) => {
    if (selectedSlotCorrection.includes(slotCorrection)) {
      setSelectedSlotCorrection(
        selectedSlotCorrection.filter((item) => item !== slotCorrection)
      );
    } else {
      setSelectedSlotCorrection([...selectedSlotCorrection, slotCorrection]);
    }
  };
  const handleSlotCorrectionAll = () => {
    if (selectedSlotCorrection.length === slotCorrectionResults.length) {
      setSelectedSlotCorrection([]);
    } else {
      setSelectedSlotCorrection(slotCorrectionResults);
    }
  };

  const statusSelection = [
    {
      display: "All Status",
      disabled: false,
      value: -1,
    },
    {
      display: ESlotCorrectionStatus[0],
      disabled: false,
      value: ESlotCorrectionStatus.Normal,
    },
    {
      display: ESlotCorrectionStatus[1],
      disabled: false,
      value: ESlotCorrectionStatus.Corrected,
    },
    {
      display: ESlotCorrectionStatus[2],
      disabled: false,
      value: ESlotCorrectionStatus.Error,
    },
  ] as StatusValue[];

  const [selectedStatus, setSelectedStatus] = useState(-1);

  /*--------PAGINATION--------*/
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const [currentItems, setCurrentItems] = useState<SlotCorrectionResult[]>(
    slotCorrectionResults.slice(indexOfFirstItem, indexOfLastItem)
  );

  useEffect(() => {
    console.log("selectedStatus useEffect", selectedStatus);

    if (selectedStatus === -1) {
      setCurrentItems(
        slotCorrectionResults.slice(indexOfFirstItem, indexOfLastItem)
      );
    }
    if (selectedStatus !== -1) {
      setCurrentItems(
        slotCorrectionResults
          .filter((item) => item.status === selectedStatus)
          .slice(indexOfFirstItem, indexOfLastItem)
      );
    }
  }, [currentPage, slotCorrectionResults, selectedStatus]);

  /*--------OFFSET WAYPOINT--------*/
  // const [waypoint, setWaypoint] = useState(null as CartesianWaypoint | null);
  // const [isWaypointUpdated, setIsWaypointUpdated] = useState(false);

  // const onCartesianWaypointUpdated = (waypoint: CartesianWaypoint) => {
  //   setWaypoint(waypoint);
  //   setIsWaypointUpdated(true);
  // };

  const handleDeleteResult = () => {
    CalibrationApi.deleteSlotCorrection(selectedSlotCorrection).then(
      (result) => {
        setNeedFetChSlotCorrectionResult(true);
        setSelectedSlotCorrection([]);
        setIsSlotCorrectionUpdated(true);
      }
    );
  };

  const handleEditOffset = (
    value: number,
    axis: "x" | "y" | "z",
    isRetrieve: boolean,
    slotCorrectionResult: SlotCorrectionResult
  ) => {
    if (isRetrieve) {
      if (slotCorrectionResult.retrieveOffset == null) {
        slotCorrectionResult.retrieveOffset = {
          x: 0,
          y: 0,
          z: 0,
        };
      }
      switch (axis) {
        case "x":
          slotCorrectionResult.retrieveOffset.x = value;
          break;
        case "y":
          slotCorrectionResult.retrieveOffset.y = value;
          break;
        case "z":
          slotCorrectionResult.retrieveOffset.z = value;
          break;
      }
    } else {
      if (slotCorrectionResult.storeOffset == null) {
        slotCorrectionResult.storeOffset = {
          x: 0,
          y: 0,
          z: 0,
        };
      }
      switch (axis) {
        case "x":
          slotCorrectionResult.storeOffset.x = value;
          break;
        case "y":
          slotCorrectionResult.storeOffset.y = value;
          break;
        case "z":
          slotCorrectionResult.storeOffset.z = value;
          break;
      }
    }

    let indexSelected = selectedSlotCorrection.findIndex(
      (slotCorr) =>
        slotCorr.carrier == slotCorrectionResult.carrier &&
        slotCorr.hotelNumber == slotCorrectionResult.hotelNumber &&
        slotCorr.slotNumber == slotCorrectionResult.slotNumber
    );

    if (indexSelected != -1) {
      let newSelectedSlots = [...selectedSlotCorrection];
      newSelectedSlots[indexSelected] = slotCorrectionResult;
      setSelectedSlotCorrection(newSelectedSlots);
    }

    let indexAll = slotCorrectionResults.findIndex(
      (slotCorr) =>
        slotCorr.carrier == slotCorrectionResult.carrier &&
        slotCorr.hotelNumber == slotCorrectionResult.hotelNumber &&
        slotCorr.slotNumber == slotCorrectionResult.slotNumber
    );

    if (indexAll != -1) {
      let newAllSlotsCorr = [...slotCorrectionResults];
      newAllSlotsCorr[indexAll] = slotCorrectionResult;
      setSlotCorrectionResults(newAllSlotsCorr);
    }

    let indexUpdated = updatedSlotCorrectionResults.findIndex(
      (slotCorr) =>
        slotCorr.carrier == slotCorrectionResult.carrier &&
        slotCorr.hotelNumber == slotCorrectionResult.hotelNumber &&
        slotCorr.slotNumber == slotCorrectionResult.slotNumber
    );

    if (indexUpdated != -1) {
      let newUpdatedSlotCorrection = [...updatedSlotCorrectionResults];
      newUpdatedSlotCorrection[indexUpdated] = slotCorrectionResult;
      setUpdatedSlotCorrectionResults(newUpdatedSlotCorrection);
    } else {
      setUpdatedSlotCorrectionResults([
        ...updatedSlotCorrectionResults,
        slotCorrectionResult,
      ]);
    }

    setIsSlotCorrectionUpdated(true);
  };

  const handleStorePlate = () => {
    const slotCorrection = selectedSlotCorrection[0];
    ToolsApi.storePlateWithOverrideSlotCorrection(
      chamberModule.identifier,
      slotCorrection.hotelNumber,
      slotCorrection.slotNumber,
      EAutoCalibrationResult.CurrentAutoCalibration,
      slotCorrection
    );
  };

  const handleRetrievePlate = () => {
    const slotCorrection = selectedSlotCorrection[0];
    ToolsApi.retrievePlateWithOverrideSlotCorrection(
      chamberModule.identifier,
      slotCorrection.hotelNumber,
      slotCorrection.slotNumber,
      EAutoCalibrationResult.CurrentAutoCalibration,
      slotCorrection
    );
  };

  console.log("selectedStatus", selectedStatus);

  return (
    <div>
      <div className="flex-between">
        <h2
          style={{
            fontFamily: "Roboto",
            fontSize: "24px",
            fontWeight: 400,
            textAlign: "left",
            margin: "0 0 21px 0",
          }}
        >
          Correction Result
        </h2>
        <div className="flex-between" style={{ gap: 8 }}>
          {selectedSlotCorrection.length > 0 && (
            <div className="flex-between" style={{ gap: "8px" }}>
              <div className="flex-between" style={{ gap: 8 }}>
                <div
                  style={{
                    backgroundColor: "#F5F5F5",
                    height: 32,
                    padding: "9px 8px",
                    borderRadius: 4,
                    color: "#474747",
                  }}
                >
                  {selectedSlotCorrection.length} Selected
                </div>
                <MtiButton
                  colorVariant="error"
                  variant="secondary"
                  size="medium"
                  onClick={handleDeleteResult}
                  style={{
                    minWidth: 32,
                    paddingTop: 5,
                    paddingBottom: 5,
                  }}
                >
                  <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 4L0 2L5 2L5 0L11 0V2L16 2L16 4L0 4ZM6 2L6 1L10 1V2L6 2Z"
                      fill="#FF5252"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15 6L1 6L1 20L15 20L15 6ZM5 8L3 8L3 18H5L5 8ZM9 8H7L7 18L9 18L9 8ZM11 8L13 8L13 18H11L11 8Z"
                      fill="#FF5252"
                    />
                  </svg>
                </MtiButton>
              </div>
              <Divider />
              <div className="flex-between" style={{ gap: 8 }}>
                <MtiButton
                  colorVariant="alternate"
                  variant="secondary"
                  size="medium"
                  disabled={
                    selectedSlotCorrection.length !== 1 ||
                    selectedSlotCorrection[0].status ==
                      ESlotCorrectionStatus.Error
                  }
                  onClick={handleStorePlate}
                  style={{
                    height: 32,
                    // borderColor: "#B4B4B4",
                    // color: "#313131",
                  }}
                >
                  Store
                </MtiButton>
                <MtiButton
                  colorVariant="alternate"
                  variant="secondary"
                  size="medium"
                  disabled={
                    selectedSlotCorrection.length !== 1 ||
                    selectedSlotCorrection[0].status ==
                      ESlotCorrectionStatus.Error
                  }
                  onClick={handleRetrievePlate}
                  style={{
                    height: 32,
                    // borderColor: "#B4B4B4",
                    // color: "#313131",
                  }}
                >
                  Retrieve
                </MtiButton>
              </div>
              <Divider />
            </div>
          )}

          <CommonDropDown<number>
            value={selectedStatus}
            id="status-select"
            onChange={(value) =>
              setSelectedStatus(value as ESlotCorrectionStatus)
            }
            style={{
              width: 150,
              height: 32,
              borderRadius: 4,
            }}
            dropDownDisplayValues={statusSelection}
          />
        </div>
      </div>
      <div className="scroll-container">
        <table className="slot-correction-table">
          <thead>
            <tr>
              <th>
                <CheckBox
                  checked={
                    selectedSlotCorrection.length ===
                      slotCorrectionResults.length &&
                    slotCorrectionResults.length !== 0
                  }
                  id="slot-correction-result-all"
                  name="slot-correction-result-all"
                  onChange={() => handleSlotCorrectionAll()}
                  colorVariant="alternate"
                  size="small"
                />
              </th>
              {header.map((item, index) => (
                <th key={index}>{item}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, index) => (
              <tr
                key={index}
                style={{ height: "48px" }}
                className={
                  selectedSlotCorrection.includes(item)
                    ? "slot-correction-table-tr selected"
                    : "slot-correction-table-tr"
                }
              >
                <td>
                  <CheckBox
                    checked={selectedSlotCorrection.includes(item)}
                    id={`slot-correction-result-${index}`}
                    name={`slot-correction-result-${index}`}
                    onChange={() => handleSlotCorrection(item)}
                    colorVariant="alternate"
                    size="small"
                  />
                </td>
                <td
                  style={{
                    textAlign: "left",
                    color:
                      ESlotCorrectionStatus[item.status] === "Error"
                        ? "red"
                        : "#414141",
                  }}
                >
                  {AutoCalibrationUtil.getCarrierName(item.carrier)}
                </td>
                <td
                  style={{
                    color:
                      ESlotCorrectionStatus[item.status] === "Error"
                        ? "red"
                        : "#414141",
                  }}
                >
                  {item.hotelNumber}
                </td>
                <td
                  style={{
                    color:
                      ESlotCorrectionStatus[item.status] === "Error"
                        ? "red"
                        : "#414141",
                  }}
                >
                  {item.slotNumber}
                </td>
                <td>{item.storeOffset?.x.toFixed(2) ?? 0}</td>
                <td>{item.storeOffset?.y.toFixed(2) ?? 0}</td>
                <td>{item.storeOffset?.z.toFixed(2) ?? 0}</td>
                <td>{item.retrieveOffset?.x.toFixed(2) ?? 0}</td>
                <td>{item.retrieveOffset?.y.toFixed(2) ?? 0}</td>
                <td>{item.retrieveOffset?.z.toFixed(2) ?? 0}</td>
                <td
                  style={{
                    color:
                      ESlotCorrectionStatus[item.status] === "Error"
                        ? "red"
                        : "#414141",
                  }}
                >
                  {ESlotCorrectionStatus[item.status]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <p>{`${indexOfFirstItem + 1}-${Math.min(
          indexOfLastItem,
          slotCorrectionResults.length
        )} of ${slotCorrectionResults.length}`}</p>
        <div>
          <svg
            onClick={() =>
              setCurrentPage(currentPage > 1 ? currentPage - 1 : currentPage)
            }
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.25 18L20.9167 24.6667L20.9167 11.3333L14.25 18Z"
              fill="#B4B4B4"
            />
          </svg>
          <svg
            onClick={() =>
              setCurrentPage(
                currentPage <
                  Math.ceil(slotCorrectionResults.length / itemsPerPage)
                  ? currentPage + 1
                  : currentPage
              )
            }
            transform="rotate(180)"
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.25 18L20.9167 24.6667L20.9167 11.3333L14.25 18Z"
              fill="#B4B4B4"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
